import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnChanges,
    SimpleChanges,
    OnInit,
    OnDestroy,
    Renderer2,
    ViewChild,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";

@Component({
    selector: "app-opcoes-table",
    templateUrl: "./opcoes-table.component.html",
    standalone: false,
})
export class OpcoesTableComponent implements OnChanges, OnInit, OnDestroy {
    static notificadorAbertura = new Subject<OpcoesTableComponent>();
    private inscricao!: Subscription;

    @ViewChild("menu", { static: true }) menuRef!: ElementRef<HTMLUListElement>;

    showOptions = false;
    popupStyle = {};
    @Input() opcoes: any;
    @Input() value: any;
    @Input() direita = false;

    _options: any;

    private appended = false;
    private anchorEl?: HTMLElement;
    private onScrollBound = () => this.onScroll();

    constructor(private renderer: Renderer2) {}

    ngOnInit(): void {
        this.inscricao = OpcoesTableComponent.notificadorAbertura.subscribe(
            (componenteAberto) => {
                if (componenteAberto !== this && this.showOptions) {
                    this.showOptions = false;
                }
            },
        );

        document.addEventListener("scroll", this.onScrollBound, true);
    }

    ngOnDestroy(): void {
        if (this.inscricao) {
            this.inscricao.unsubscribe();
        }
        document.removeEventListener("scroll", this.onScrollBound, true);

        if (this.appended) {
            this.menuRef.nativeElement.remove();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.opcoes) this.options = this.opcoes;
    }

    set options(v) {
        if (
            this._options !== undefined &&
            this._options !== null &&
            Array.isArray(this._options) &&
            this._options.length
        )
            return;
        this._options = v.slice(0);
    }

    get options() {
        return this._options;
    }

    exibirOpcoes(e: any) {
        e.stopPropagation();
        this.showOptions = !this.showOptions;

        if (this.showOptions) {
            const anchor = e.currentTarget as HTMLElement;
            this.anchorEl = anchor;

            if (!this.appended) {
                this.renderer.appendChild(
                    document.body,
                    this.menuRef.nativeElement,
                );
                this.appended = true;
            }

            OpcoesTableComponent.notificadorAbertura.next(this);

            requestAnimationFrame(() => {
                if (this.showOptions) {
                    this.atualizarPosicaoMenu(anchor);
                }
            });
        }
    }

    esconderOpcoes(e: any) {
        this.showOptions = false;
    }

    @HostListener("window:resize")
    fecharNoResize() {
        if (this.showOptions) {
            this.showOptions = false;
        }
    }

    private onScroll() {
        const anchor = this.anchorEl;
        if (this.showOptions && anchor) {
            this.atualizarPosicaoMenu(anchor);
        }
    }

    atualizarPosicaoMenu(target: HTMLElement) {
        const margem = 12;
        const rect = target.getBoundingClientRect();
        const larguraViewport = document.documentElement.clientWidth;

        const maiorLabel = Math.max(
            ...this.options.map((o: any) => o.label?.length ?? 0),
        );
        const larguraEstimada = maiorLabel * 8 + 56; 
        const larguraDesejada = Math.max(
            this.direita ? 200 : 160,
            larguraEstimada,
        );

        const larguraDisponivel = larguraViewport - margem * 2;
        const larguraMenu = Math.min(larguraDesejada, larguraDisponivel);

        let left = rect.left + rect.width / 2 - larguraMenu / 2;
        left = Math.max(margem, left);
        left = Math.min(left, larguraViewport - larguraMenu - margem);
        left = left + window.scrollX;

        const top = rect.bottom + window.scrollY + 6;

        this.popupStyle = {
            top: `${top}px`,
            left: `${left}px`,
            width: `${larguraMenu}px`,
        };
    }

    opcaoClicada(e: any, opcao: any) {
        this.esconderOpcoes(e);
        opcao.command(this.value);
    }
}
